export const NB_MAX_LIVES = 3;
export const NB_MAX_ENERGY = 10;